import Component from '../abstracts/Component';

export default class ProductOpenedComponent extends Component {

  get SELECTORS() {
    return {
      productOpened: 'productOpened',
      dialogShown: 'dialogShown'
    }
  }

  get CLASSES() {
    return {
    }
  }

  constructor() {

    super();
  }

  render() {
    this.log('rendering...');
    if (sessionStorage.getItem(this.SELECTORS.productOpened) == null) {
      sessionStorage.setItem(this.SELECTORS.productOpened, true);
    }
    if (sessionStorage.getItem(this.SELECTORS.dialogShown) == null) {
      sessionStorage.setItem(this.SELECTORS.dialogShown, false);
    }
  }
}




